import { ValidationError } from '@queries/generated';
import { map } from 'rxjs/operators';

interface Errorable {
  errors?: ValidationError[];
}

export function finalMap<T extends Errorable, K extends keyof T>(key: K) {
  return map((resp: T): T[K] => {
    if (resp.errors.length) {
      throw resp.errors;
    }
    return resp[key];
  });
}

export function castAs<T>() {
  return map((value) => value as unknown as T);
}
